module.exports = __webpack_public_path__ + "img/icons-3.23de5b41.png";